import {FaqSearcher} from "@/domain/support/helper";

const state = {
    events: [],
    faqs: [],
    faqsSearchResults: []
}

export const getters = {
    events: state => state.events,
    faqs: state => state.faqs,
    faqsSearchResults: state => state.faqsSearchResults
}


export const mutations = {
    setAvailableEvents(state, events) {
        state.events = events
    },
    setAvailableFaqs(state, faqs) {
        state.faqs = faqs
    },
    searchInFaqs(state, q) {
        const searcher = new FaqSearcher(state.faqs)
        state.faqsSearchResults = searcher.search(q)
    }
}


export const actions = (supportService) => ({
    async fetchAvailableEvents({commit}) {
        const events = await supportService.getEvents()
        commit('setAvailableEvents', events)
    },
    async fetchAvailableFaqs({commit}, event_id) {
        const faqs = await supportService.getFaqs(event_id)
        commit('setAvailableFaqs', faqs)
    },
    async searchInFaqs({commit}, q) {
        commit('searchInFaqs', q)
    },
    // eslint-disable-next-line no-unused-vars
    async sendRequest({commit}, payload) {
        await supportService.sendRequest(payload)
    }
})

export default supportService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(supportService)
})
